"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultCategorySpend = exports.DEFAULT_TOTAL_SPEND = exports.CATEGORIES = exports.CATEGORY_NAMES = void 0;

var _CATEGORIES;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Thee are the CC spending category names that marketplace api will accept
 */
var CATEGORY_NAMES = {
  DINING: 'dining',
  GAS: 'gas',
  GROCERY: 'groceries',
  TRAVEL: 'travel',
  OTHER: 'other'
};
/**
 * The spend in here is the "default" spend per category.
 * These defaults are based on national consumer expenditure data
 * This first overridden by category (the default spend per category is different for travel card
 * searches)
 * This is next overridden by what the user inputs in the rewards breakdown modal on the
 * recommendation results page
 */

exports.CATEGORY_NAMES = CATEGORY_NAMES;
var CATEGORIES = (_CATEGORIES = {}, _defineProperty(_CATEGORIES, CATEGORY_NAMES.DINING, {
  displayName: 'Dining',
  name: CATEGORY_NAMES.DINING,
  icon: 'restaurant',
  spendPct: 0.15,
  rewards: 0
}), _defineProperty(_CATEGORIES, CATEGORY_NAMES.GAS, {
  displayName: 'Gas',
  name: CATEGORY_NAMES.GAS,
  icon: 'local_gas_station',
  spendPct: 0.1,
  rewards: 0
}), _defineProperty(_CATEGORIES, CATEGORY_NAMES.GROCERY, {
  displayName: 'Grocery & drug',
  name: CATEGORY_NAMES.GROCERY,
  icon: 'local_grocery_store',
  spendPct: 0.2,
  rewards: 0
}), _defineProperty(_CATEGORIES, CATEGORY_NAMES.TRAVEL, {
  displayName: 'Travel',
  name: CATEGORY_NAMES.TRAVEL,
  icon: 'airplanemode_active',
  spendPct: 0.05,
  rewards: 0
}), _defineProperty(_CATEGORIES, CATEGORY_NAMES.OTHER, {
  displayName: 'Everything else',
  name: CATEGORY_NAMES.OTHER,
  icon: 'local_offer',
  spendPct: 0.5,
  rewards: 0
}), _CATEGORIES);
/**
 * When calculating a default category spend, we utilize the spendPct of each category,
 * and aim for this total
 */

exports.CATEGORIES = CATEGORIES;
var DEFAULT_TOTAL_SPEND = 2000;
/**
 * This is the object of default category spend values
 */

exports.DEFAULT_TOTAL_SPEND = DEFAULT_TOTAL_SPEND;
var defaultCategorySpend = {};
exports.defaultCategorySpend = defaultCategorySpend;
Object.keys(CATEGORIES).forEach(function (categoryName) {
  defaultCategorySpend[categoryName] = DEFAULT_TOTAL_SPEND * CATEGORIES[categoryName].spendPct;
});